
module.exports = function getResource(label) {
    const resources = {
        color: 'Couleur',
        size: 'Format',
        edit: 'Modifier',
        doNotSubstitute: 'Ne pas remplacer',
        substituteWith: 'Remplacer par : '
    };

    return resources[label];
};
